/* FRAWGRAPHY — interactions */
(() => {
  'use strict';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /* ── Dil ──────────────────────────────────────────────────
     Kaynak dil TR: sayfadaki metin zaten Türkçe. EN'e geçerken
     sözlükten yazıyor, TR'ye dönerken ilk hâli geri koyuyoruz. */
  const LANG_KEY = 'frawgraphy-lang';
  const dict = (window.FRAWGRAPHY_I18N && window.FRAWGRAPHY_I18N.en) || {};
  const originals = new Map();

  // Sözlükte karşılığı yoksa Türkçesine düşer. dict boş da olabilir
  // (i18n.js yüklenmemişse), o yüzden her çeviri buradan geçmeli —
  // doğrudan dict[k] okumak metni undefined'a çeviriyordu.
  const isEn = () => document.documentElement.getAttribute('data-lang') === 'en';
  const msg = (key, tr) => (isEn() && dict[key] ? dict[key] : tr);

  const i18nNodes = $$('[data-i18n], [data-i18n-html], [data-i18n-attr], [data-i18n-meta]');
  i18nNodes.forEach((el) => {
    if (el.hasAttribute('data-i18n')) originals.set(el, el.textContent);
    else if (el.hasAttribute('data-i18n-html')) originals.set(el, el.innerHTML);
    else if (el.hasAttribute('data-i18n-meta')) originals.set(el, el.getAttribute('content'));
    if (el.hasAttribute('data-i18n-attr')) {
      const [attr] = el.dataset.i18nAttr.split(':');
      originals.set(el.dataset.i18nAttr + '|' + i18nNodes.indexOf(el), el.getAttribute(attr));
    }
  });
  const originalTitle = document.title;

  const applyLang = (lang) => {
    const en = lang === 'en';
    document.documentElement.setAttribute('lang', en ? 'en' : 'tr');
    document.documentElement.setAttribute('data-lang', lang);

    i18nNodes.forEach((el, idx) => {
      if (el.hasAttribute('data-i18n')) {
        const k = el.dataset.i18n;
        el.textContent = en && dict[k] ? dict[k] : originals.get(el);
      }
      if (el.hasAttribute('data-i18n-html')) {
        const k = el.dataset.i18nHtml;
        el.innerHTML = en && dict[k] ? dict[k] : originals.get(el);
      }
      if (el.hasAttribute('data-i18n-meta')) {
        const k = el.dataset.i18nMeta;
        el.setAttribute('content', en && dict[k] ? dict[k] : originals.get(el));
      }
      if (el.hasAttribute('data-i18n-attr')) {
        const [attr, k] = el.dataset.i18nAttr.split(':');
        const key = el.dataset.i18nAttr + '|' + idx;
        el.setAttribute(attr, en && dict[k] ? dict[k] : originals.get(key));
      }
    });

    // text-transform: uppercase yerel kurala göre çalışır: İngilizce metinde
    // "i" → "I", Türkçe metinde "i" → "İ". Bu yüzden lang de dille birlikte döner.
    // data-tr-lang="en": Türkçe modda bile İngilizce kalan terimler (Editorial, Lookbook…).
    i18nNodes.forEach((el) => {
      if (!el.hasAttribute('data-i18n') && !el.hasAttribute('data-i18n-html')) return;
      el.setAttribute('lang', en ? 'en' : (el.dataset.trLang || 'tr'));
    });

    // Başlık yalnızca sayfa kendi anahtarını bildirmişse çevrilir.
    // Yazı sayfaları anahtar bildirmez; başlıkları Türkçe kalır.
    const titleKey = document.body.dataset.titleKey;
    if (titleKey) document.title = en && dict[titleKey] ? dict[titleKey] : originalTitle;

    $$('[data-lang-btn]').forEach((b) => {
      b.setAttribute('aria-pressed', String(b.dataset.langBtn === lang));
    });
  };

  let storedLang = 'tr';
  try { storedLang = localStorage.getItem(LANG_KEY) || 'tr'; } catch (e) { /* ignore */ }
  applyLang(storedLang);

  $$('[data-lang-btn]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const lang = btn.dataset.langBtn;
      applyLang(lang);
      // Tema düğmesinin gizli etiketi sözlükten gelmiyor; dille birlikte tazelenmeli
      applyTheme(document.documentElement.getAttribute('data-theme') || 'dark');
      try { localStorage.setItem(LANG_KEY, lang); } catch (e) { /* ignore */ }
      if (typeof refreshIndicator === 'function') refreshIndicator();
    });
  });

  /* ── Tema anahtarı ────────────────────────────────────── */
  const themeToggle = $('[data-theme-toggle]');
  const themeLabel = $('[data-theme-label]');
  const THEME_KEY = 'frawgraphy-theme';

  const applyTheme = (theme) => {
    document.documentElement.setAttribute('data-theme', theme);
    if (!themeToggle) return;
    const toLight = theme === 'dark';
    themeToggle.setAttribute('aria-pressed', String(theme === 'light'));
    themeLabel.textContent = toLight
      ? msg('theme.toLight', 'Aydınlık temaya geç')
      : msg('theme.toDark', 'Karanlık temaya geç');
  };

  applyTheme(document.documentElement.getAttribute('data-theme') || 'dark');

  if (themeToggle) {
    themeToggle.addEventListener('click', () => {
      const next = document.documentElement.getAttribute('data-theme') === 'light' ? 'dark' : 'light';
      applyTheme(next);
      try { localStorage.setItem(THEME_KEY, next); } catch (e) { /* private mode */ }
    });
  }

  // Kullanıcı kendi seçimini yapmadıysa sistem tercihini izle
  window.matchMedia('(prefers-color-scheme: light)').addEventListener('change', (e) => {
    let stored = null;
    try { stored = localStorage.getItem(THEME_KEY); } catch (err) { /* ignore */ }
    if (!stored) applyTheme(e.matches ? 'light' : 'dark');
  });

  /* ── Header state + scroll progress ───────────────────── */
  const header = $('[data-header]');
  const progress = $('[data-progress]');

  let scrollQueued = false;
  const onScroll = () => {
    scrollQueued = false;
    const y = window.scrollY;
    if (header) header.toggleAttribute('data-scrolled', y > 24);
    if (progress) {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      progress.style.width = max > 0 ? `${Math.min((y / max) * 100, 100)}%` : '0%';
    }
  };
  window.addEventListener('scroll', () => {
    if (!scrollQueued) { scrollQueued = true; requestAnimationFrame(onScroll); }
  }, { passive: true });
  onScroll();

  /* ── Hero katman paralaksı ────────────────────────────── */
  const hero = $('[data-hero]');
  const stage = $('[data-stage]');
  const layers = $$('[data-depth]');

  // hero.jpg henüz konmadıysa kırık görsel yerine degradeye düş
  const heroImg = $('.hero-plate img');
  if (heroImg) {
    heroImg.addEventListener('error', () => { heroImg.style.display = 'none'; });
  }

  const revealPlate = $('[data-reveal]');
  const reticle = $('[data-reticle]');

  if (hero && stage && canHover && !reduceMotion) {
    let raf = null;
    let px = 0, py = 0, nx = 0, ny = 0;

    /* Mercek kutusu sahne kadar değil mercek kadar (style.css). İçindeki
       kare ters yönde kayarak sahnede çakılı duruyor, ama bunun birebir
       oturması için karenin sahnenin ölçüsünde olması gerekiyor. */
    const setStageSize = () => {
      const r = stage.getBoundingClientRect();
      hero.style.setProperty('--stage-w', `${r.width}px`);
      hero.style.setProperty('--stage-h', `${r.height}px`);
    };
    /* `resize` YETMEZ: sahne, pencere hiç değişmeden de daralır — sayfa
       yeterince uzayıp dikey kaydırma çubuğu belirdiğinde genişlik 15 px
       düşer ve resize olayı hiç kurulmaz. Ölçüldü 2026-09-20: kare 1440 px
       olarak donup kalmışken sahne 1425 px'ti; object-fit ortaladığı için
       mercekteki fotoğraf 7,5 px yana kayıyordu. ResizeObserver kutunun
       kendisini izler, sebebi ne olursa olsun. */
    setStageSize();
    if ('ResizeObserver' in window) {
      new ResizeObserver(setStageSize).observe(stage);
    } else {
      let sizeQueued = false;
      window.addEventListener('resize', () => {
        if (sizeQueued) return;
        sizeQueued = true;
        requestAnimationFrame(() => { sizeQueued = false; setStageSize(); });
      });
    }

    const paint = () => {
      raf = null;
      if (revealPlate) {
        revealPlate.style.setProperty('--lens-x', `${px}px`);
        revealPlate.style.setProperty('--lens-y', `${py}px`);
      }
      if (reticle) {
        reticle.style.setProperty('--lens-px', `${px}px`);
        reticle.style.setProperty('--lens-py', `${py}px`);
      }
      layers.forEach((el) => {
        const d = parseFloat(el.dataset.depth);
        el.style.transform = `translate3d(${nx * d * 100}px, ${ny * d * 100}px, 0)`;
      });
    };

    hero.addEventListener('pointermove', (e) => {
      if (e.pointerType !== 'mouse') return;
      const r = stage.getBoundingClientRect();
      px = e.clientX - r.left;
      py = e.clientY - r.top;
      nx = (px / r.width) * 2 - 1;
      ny = (py / r.height) * 2 - 1;
      if (!raf) raf = requestAnimationFrame(paint);
    });

    hero.addEventListener('pointerenter', (e) => {
      if (e.pointerType !== 'mouse') return;
      hero.setAttribute('data-lens-active', '');
      if (revealPlate) revealPlate.style.setProperty('--lens-r', '150px');
    });

    hero.addEventListener('pointerleave', () => {
      hero.removeAttribute('data-lens-active');
      if (revealPlate) revealPlate.style.setProperty('--lens-r', '0px');
      layers.forEach((el) => { el.style.transform = ''; });
    });
  }

  /* ── Scroll reveal ────────────────────────────────────── */
  const revealables = $$('.reveal');

  if (reduceMotion || !('IntersectionObserver' in window)) {
    revealables.forEach((el) => el.classList.add('is-visible'));
  } else {
    // Aynı bölümdeki elemanlar sırayla girsin
    const groups = new Map();
    revealables.forEach((el) => {
      const key = el.closest('section') || document.body;
      const list = groups.get(key) || [];
      list.push(el);
      groups.set(key, list);
    });
    groups.forEach((list) => list.forEach((el, i) => el.style.setProperty('--i', Math.min(i, 6))));

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });

    revealables.forEach((el) => io.observe(el));
  }

  /* ── Sekmeler: aktif bölüm takibi + gösterge ──────────── */
  const tabs = $$('[data-tab]');
  const indicator = $('[data-indicator]');
  const sections = $$('[data-section]');

  const moveIndicator = (tab) => {
    if (!indicator) return;
    if (!tab) { indicator.removeAttribute('data-visible'); return; }
    indicator.style.width = `${tab.offsetWidth}px`;
    indicator.style.transform = `translateX(${tab.offsetLeft}px)`;
    indicator.setAttribute('data-visible', '');
  };

  const setActive = (id) => {
    let active = null;
    tabs.forEach((tab) => {
      const isCurrent = tab.getAttribute('href') === `#${id}`;
      tab.setAttribute('aria-current', String(isCurrent));
      if (isCurrent) active = tab;
    });
    moveIndicator(active);
  };

  if (sections.length && 'IntersectionObserver' in window) {
    const spy = new IntersectionObserver((entries) => {
      const visible = entries
        .filter((e) => e.isIntersecting)
        .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
      if (visible) setActive(visible.target.id);
    }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });

    sections.forEach((s) => spy.observe(s));
  }

  // Hero'daysak: sekme vurgusu yok, tema düğmesi gizli.
  // Hero geçilince header'a data-past-hero düşer ve düğme belirir.
  if (hero && 'IntersectionObserver' in window) {
    const heroSpy = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        const onHero = e.isIntersecting && e.intersectionRatio > 0.5;
        if (onHero) {
          tabs.forEach((t) => t.setAttribute('aria-current', 'false'));
          moveIndicator(null);
        }
        if (header) header.toggleAttribute('data-past-hero', !onHero);
      });
    }, { threshold: [0.5] });
    heroSpy.observe(hero);
  } else if (header) {
    header.setAttribute('data-past-hero', '');
  }

  function refreshIndicator() {
    const active = tabs.find((t) => t.getAttribute('aria-current') === 'true');
    if (active) moveIndicator(active);
  }
  window.addEventListener('resize', refreshIndicator);

  /* ── Mobil menü ───────────────────────────────────────── */
  const menuToggle = $('[data-menu-toggle]');
  const menu = $('[data-menu]');

  if (menuToggle && menu) {
    const closeMenu = () => {
      menu.hidden = true;
      menuToggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    };

    menuToggle.addEventListener('click', () => {
      if (menuToggle.getAttribute('aria-expanded') === 'true') { closeMenu(); return; }
      menu.hidden = false;
      menuToggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      $('a', menu).focus();
    });

    $$('a', menu).forEach((a) => a.addEventListener('click', closeMenu));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && menuToggle.getAttribute('aria-expanded') === 'true') {
        closeMenu();
        menuToggle.focus();
      }
    });
  }

  /* ── Büyütme katmanı ──────────────────────────────────────
     Karusel ve üretken görsel ızgarası aynı katmanı paylaşır.
     Açan taraf kare listesini ({src, alt}), başlangıç indeksini ve
     isteğe bağlı bir `sync` geri çağrısını verir — karusel katmanla
     birlikte kayar, ızgarada eşitlenecek bir şey yoktur. */
  const lightbox = (() => {
    const el = $('[data-lightbox]');
    if (!el) return null;

    const imgEl = $('[data-lb-img]', el);
    const countEl = $('[data-lb-count]', el);
    const closeBtn = $('[data-lb-close]', el);

    // Albüm şeridi: açık karenin altında serinin diğer kareleri küçük hâlde
    const strip = document.createElement('div');
    strip.className = 'lightbox-strip';
    strip.setAttribute('data-lb-strip', '');
    const stripInner = document.createElement('div');
    stripInner.className = 'lightbox-strip-inner';
    strip.appendChild(stripInner);
    el.appendChild(strip);

    let frames = [];
    let thumbs = [];
    let index = 0;
    let sync = null;
    let lastFocus = null;

    const buildStrip = () => {
      stripInner.textContent = '';
      thumbs = frames.map((f, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'lightbox-thumb';
        b.setAttribute('aria-label', f.alt || String(i + 1));
        const im = document.createElement('img');
        im.src = f.thumb || f.src;
        im.alt = '';
        im.decoding = 'async';
        b.appendChild(im);
        b.addEventListener('click', () => { index = i; paint(); if (sync) sync(index); });
        stripInner.appendChild(b);
        return b;
      });
      el.toggleAttribute('data-has-strip', frames.length > 1);
    };

    const paint = () => {
      const f = frames[index];
      imgEl.src = f.src;
      imgEl.alt = f.alt;
      countEl.textContent = `${index + 1} / ${frames.length}`;

      thumbs.forEach((b, i) => b.setAttribute('aria-current', String(i === index)));
      const act = thumbs[index];
      if (act) {
        strip.scrollTo({
          left: Math.max(0, act.offsetLeft - (strip.clientWidth - act.offsetWidth) / 2),
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
      }
    };

    const go = (step) => {
      index = ((index + step) % frames.length + frames.length) % frames.length;
      paint();
      if (sync) sync(index);
    };

    const close = () => {
      if (el.hidden) return;
      el.removeAttribute('data-open');
      document.body.style.overflow = '';
      if (reduceMotion) el.hidden = true;
      else setTimeout(() => { el.hidden = true; }, 320);
      if (lastFocus) lastFocus.focus();
      sync = null;
    };

    const open = (list, i, opts = {}) => {
      if (!list.length) return;
      frames = list;
      index = i;
      sync = opts.sync || null;
      buildStrip();
      paint();

      // Kareler odaklanamaz (tabindex -1); tıklama gelmişse activeElement
      // body olur. O durumda açan bölüme döneriz, yoksa klavye kullanıcısı
      // katman kapanınca sayfanın başına düşer.
      const prev = document.activeElement;
      lastFocus = (prev && prev !== document.body) ? prev : (opts.returnFocus || null);

      el.hidden = false;
      document.body.style.overflow = 'hidden';
      void el.offsetWidth;                    // geçişin başlaması için reflow
      el.setAttribute('data-open', '');
      closeBtn.focus();
    };

    closeBtn.addEventListener('click', close);
    $('[data-lb-prev]', el).addEventListener('click', () => go(-1));
    $('[data-lb-next]', el).addEventListener('click', () => go(1));

    // Zemine tıklamak kapatır; görselin ve düğmelerin üstü kapatmaz
    el.addEventListener('click', (e) => {
      if (e.target.closest('.lightbox-figure, .lightbox-nav, .lightbox-close, .lightbox-strip')) return;
      close();
    });

    document.addEventListener('keydown', (e) => {
      if (el.hidden) return;
      if (e.key === 'Escape')     { close(); return; }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); go(-1); return; }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); return; }
      if (e.key !== 'Tab') return;

      // Odağı katmanın içinde döndür
      const f = $$('button', el);
      const i = f.indexOf(document.activeElement);
      e.preventDefault();
      f[((i + (e.shiftKey ? -1 : 1)) % f.length + f.length) % f.length].focus();
    });

    return { open };
  })();

  /* ── Coverflow: Work fotoğraf kütüphanesi ─────────────── */
  const coverflow = $('[data-coverflow]');

  if (coverflow) {
    const track = $('[data-cf-track]', coverflow);
    const items = $$('.coverflow-item', coverflow);
    const prevBtn = $('[data-cf-prev]', coverflow);
    const nextBtn = $('[data-cf-next]', coverflow);
    const dotsWrap = $('[data-cf-dots]', coverflow);
    const live = $('[data-cf-live]', coverflow);
    const last = items.length - 1;

    const n = items.length;
    let active = Math.floor(n / 2);
    const VISIBLE = 2;          // ±2 kare boyanır, gerisi gizlenir
    const MAX_ANGLE = 48;       // daha fazlası kareyi profilden gösterip okunmaz kılıyor
    const DRAG_THRESHOLD = 40;  // kazara sürüklemeyi önler

    // Halka üzerindeki en kısa yol: 6 kare için sonuç -3..+3 aralığına düşer.
    // (offset >= n/2) sınırı, geriye sararken karelerin yön değiştirmesini önler.
    const wrapOffset = (o) => {
      if (o >= n / 2) return o - n;
      if (o < -n / 2) return o + n;
      return o;
    };

    // Bir kare halkanın arkasından dolaştığında konumu bir adımdan fazla değişir;
    // o kareyi animasyonsuz ışınlayıp yerinde belirmesini sağlıyoruz.
    const lastOffset = new Map();

    const num = (name, fallback) => {
      const v = parseFloat(getComputedStyle(coverflow).getPropertyValue(name));
      return Number.isFinite(v) ? v : fallback;
    };

    // Noktalar
    items.forEach((_, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.addEventListener('click', () => go(i));
      dotsWrap.appendChild(b);
    });
    const dots = $$('button', dotsWrap);

    const layout = () => {
      // Adım, kartın düzen genişliğinden türetilir: kart CSS'te clamp ile
      // ölçeklendiği için binme oranı her ekran boyutunda aynı kalır.
      // offsetWidth kullanılıyor — getBoundingClientRect dönüşümü de sayar ve
      // döndürülmüş kartta olduğundan küçük bir değer döndürür.
      const itemW = items[0].offsetWidth || 300;
      const gap = itemW * num('--cf-gap-factor', 0.88);
      const angle = num('--cf-angle', 34);

      const teleported = [];

      items.forEach((el, i) => {
        const offset = wrapOffset(i - active);
        const dist = Math.abs(offset);
        const beyond = dist > VISIBLE;

        const x = offset * gap * (1 - Math.min(dist, VISIBLE) * 0.12);
        // Açı ilk komşuda tam, sonra yavaş artar; sabit çarpan kareleri profilden gösteriyordu
        const rotY = dist === 0
          ? 0
          : -Math.sign(offset) * Math.min(angle + (dist - 1) * 8, MAX_ANGLE);
        // translateZ KULLANILMIYOR: preserve-3d altında geri itilmiş düzlemlerde
        // tarayıcının isabet testi başarısız oluyor ve yan kareler tıklanamıyordu.
        // Derinlik ölçek + opaklık + rotateY ile veriliyor.
        const scale = Math.max(0.5, 1 - dist * 0.15);
        // En dıştaki halka neredeyse saydam: halkanın arkasından dolaşan kare
        // orada yer değiştirdiği için sıçrama gözle görülmez hâle gelir.
        const opacity = beyond ? 0 : (dist === 0 ? 1 : dist === 1 ? 0.72 : 0.18);

        const prev = lastOffset.get(el);
        const jumped = prev !== undefined && Math.abs(offset - prev) > 1;
        lastOffset.set(el, offset);

        if (jumped) {
          // Görünmezken yeni yerine ışınlansın, sonra oradan yumuşakça belirsin
          el.style.transition = 'none';
          el.style.opacity = '0';
          teleported.push([el, opacity]);
        } else {
          el.style.opacity = String(opacity);
        }

        el.style.transform =
          `translate3d(${x}px, 0, 0) rotateY(${rotY}deg) scale(${scale})`;
        el.style.zIndex = String(100 - dist);
        el.style.pointerEvents = beyond ? 'none' : '';
        el.toggleAttribute('data-active', offset === 0);
      });

      if (teleported.length) {
        void track.offsetWidth;   // tek seferlik reflow: ışınlanma commit edilir
        teleported.forEach(([el, opacity]) => {
          el.style.transition = '';
          el.style.opacity = String(opacity);
        });
      }

      dots.forEach((d, i) => {
        d.setAttribute('aria-current', String(i === active));
        d.setAttribute('aria-label', `${i + 1} / ${n}`);
      });

      live.textContent = `${active + 1} / ${n}`;
    };

    // Sonsuz döngü: uçlar yok, indeks halka üzerinde dolaşır
    function go(i) {
      const next = ((i % n) + n) % n;
      if (next === active) return;
      active = next;
      layout();
    }

    prevBtn.addEventListener('click', () => go(active - 1));
    nextBtn.addEventListener('click', () => go(active + 1));

    let suppressClick = false;

    // Merkezdeki kare büyütmeyi açar. Yandakiler, kaç adım uzakta olurlarsa
    // olsunlar, o taraftaki oka basılmış gibi tek adım ilerletir.
    // Sürükleme bittiğinde tetiklenen tıklamayı yutmak için suppressClick kullanılır.
    items.forEach((el, i) => {
      el.addEventListener('click', () => {
        if (suppressClick) return;
        const offset = wrapOffset(i - active);
        if (offset === 0) openLightbox(i);
        else go(active + Math.sign(offset));
      });
    });

    coverflow.addEventListener('keydown', (e) => {
      const keys = { ArrowLeft: active - 1, ArrowRight: active + 1, Home: 0, End: last };
      if (!(e.key in keys)) return;
      e.preventDefault();
      go(keys[e.key]);
    });

    // Yalnızca yatay tekerlek/trackpad; dikey sayfa kaydırma asla ele geçirilmez
    let wheelLock = false;
    track.addEventListener('wheel', (e) => {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      e.preventDefault();
      if (wheelLock) return;
      wheelLock = true;
      setTimeout(() => { wheelLock = false; }, 260);
      go(active + (e.deltaX > 0 ? 1 : -1));
    }, { passive: false });

    // Sürükleme / kaydırma
    let dragX = null;
    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragX = e.clientX;
    });
    track.addEventListener('pointerup', (e) => {
      if (dragX === null) return;
      const dx = e.clientX - dragX;
      dragX = null;
      if (Math.abs(dx) < DRAG_THRESHOLD) return;
      // Sürükleme sonrası gelen tıklama kareyi bir kez daha ilerletmesin
      suppressClick = true;
      setTimeout(() => { suppressClick = false; }, 0);
      go(active + (dx < 0 ? 1 : -1));
    });
    track.addEventListener('pointercancel', () => { dragX = null; });

    window.addEventListener('resize', layout);
    layout();

    // Katman ve karusel aynı kareyi gösterir: kapanınca kaldığın yerdesin
    function openLightbox(i) {
      if (!lightbox) return;
      const frames = items.map((li) => {
        const img = $('img', li);
        return { src: img.dataset.full || img.src, thumb: img.currentSrc || img.src, alt: img.alt };
      });
      lightbox.open(frames, i, { sync: go, returnFocus: coverflow });
    }
  }

  /* ── Üretken görsel ızgarası ──────────────────────────────
     Kartlar tam boy görsele bağlı; JS varsa aynı büyütme katmanını
     açar, yoksa bağlantı görseli doğrudan açar. */
  const digitalGrid = $('[data-digital]');

  if (digitalGrid && lightbox) {
    const hits = $$('[data-digital-hit]', digitalGrid);
    const frames = hits.map((a) => {
      const img = $('img', a);
      return { src: a.getAttribute('href'), thumb: img.currentSrc || img.src, alt: img.alt };
    });

    hits.forEach((a, i) => {
      a.addEventListener('click', (e) => {
        e.preventDefault();
        lightbox.open(frames, i, { returnFocus: a });
      });
    });
  }

  /* ── Videografi şeridi ────────────────────────────────── */
  const reel = $('[data-reel]');

  if (reel) {
    const panels = $$('[data-panel]', reel);
    const hits = panels.map((p) => $('.reel-hit', p));
    let locked = -1;   // tıklamayla sabitlenen panel; -1 = serbest

    const setActive = (i) => {
      panels.forEach((p, k) => {
        const on = k === i;
        p.toggleAttribute('data-active', on);
        hits[k].setAttribute('aria-expanded', String(on));
      });
      reel.toggleAttribute('data-has-active', i >= 0);
    };

    // Aynı anda tek video oynar; kapanan panelin videosu başa sarılır
    const play = (i) => {
      panels.forEach((p, k) => {
        const v = $('video', p);
        if (!v) return;
        if (k === i) {
          p.setAttribute('data-playing', '');
          v.play().catch(() => {
            // Kaynak yoksa afiş kalır; şeridin çalışması bundan etkilenmez
            p.removeAttribute('data-playing');
          });
        } else {
          p.removeAttribute('data-playing');
          v.pause();
          v.currentTime = 0;
        }
      });
    };

    panels.forEach((panel, i) => {
      // Üzerine gelince genişler — yalnızca gerçek imleçli cihazlarda
      if (canHover) {
        panel.addEventListener('pointerenter', (e) => {
          if (e.pointerType !== 'mouse' || locked >= 0) return;
          setActive(i);
        });
      }

      hits[i].addEventListener('click', () => {
        if (locked === i) {            // açık panele tekrar tıklamak kapatır
          locked = -1;
          setActive(-1);
          play(-1);
          return;
        }
        locked = i;
        setActive(i);
        play(i);
      });

      // Klavye: oklarla paneller arasında gezin
      hits[i].addEventListener('keydown', (e) => {
        const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
        if (step === undefined) return;
        e.preventDefault();
        const next = (i + step + panels.length) % panels.length;
        hits[next].focus();
        if (locked < 0) setActive(next);
      });

      // Klavyeyle gezerken de açılsın
      hits[i].addEventListener('focus', () => { if (locked < 0) setActive(i); });
    });

    // İmleç şeritten çıkınca serbest hâle dön (kilitli değilse)
    if (canHover) {
      reel.addEventListener('pointerleave', () => { if (locked < 0) setActive(-1); });
    }
  }

  /* ── İletişim formu ───────────────────────────────────── */
  const form = $('[data-form]');
  if (!form) return;

  const submitBtn = $('[data-submit]');
  const submitLabel = $('[data-submit-label]');
  const status = $('[data-status]');

  const rules = {
    name:  (v) => (v.trim().length >= 2 ? '' : msg('form.errName', 'Lütfen adınızı ve soyadınızı yazın.')),
    email: (v) => (/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim()) ? '' : msg('form.errEmail', 'Geçerli bir e-posta adresi girin (ör. ad@marka.com).')),
    brief: (v) => (v.trim().length >= 20 ? '' : msg('form.errBrief', 'Projeyi en az birkaç cümleyle anlatın (20+ karakter).'))
  };

  const validateField = (input) => {
    const rule = rules[input.name];
    if (!rule) return true;

    const message = rule(input.value);
    const field = input.closest('.field');
    const errEl = $(`#${input.id}-err`);

    field.toggleAttribute('data-invalid', Boolean(message));
    input.setAttribute('aria-invalid', String(Boolean(message)));
    errEl.textContent = message;
    errEl.hidden = !message;
    return !message;
  };

  // Kullanıcı alanı bitirince doğrula, yazarken değil
  Object.keys(rules).forEach((name) => {
    const input = form.elements[name];
    input.addEventListener('blur', () => validateField(input));
    input.addEventListener('input', () => {
      if (input.closest('.field').hasAttribute('data-invalid')) validateField(input);
    });
  });

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    status.textContent = '';
    status.removeAttribute('data-error');

    const inputs = Object.keys(rules).map((n) => form.elements[n]);
    const invalid = inputs.filter((input) => !validateField(input));

    if (invalid.length) {
      status.setAttribute('data-error', '');
      status.textContent = `${invalid.length} ${msg('form.errCount', 'alan düzeltilmeli.')}`;
      invalid[0].focus();
      return;
    }

    const restLabel = submitLabel.textContent;
    const rest = () => {
      submitBtn.removeAttribute('data-loading');
      submitBtn.disabled = false;
      submitLabel.textContent = restLabel;
    };

    submitBtn.disabled = true;
    submitBtn.setAttribute('data-loading', '');
    submitLabel.textContent = msg('form.sending', 'Gönderiliyor');

    // Turnstile jetonu tek kullanımlıktır: widget çözümü gizli bir alana
    // yazar, başarısız denemeden sonra tazelenmesi gerekir.
    const turnstileField = form.elements['cf-turnstile-response'];

    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name:  form.name.value.trim(),
          email: form.email.value.trim(),
          type:  form.type.value,
          brief: form.brief.value.trim(),
          lang:  document.documentElement.getAttribute('data-lang') || 'tr',
          page:  location.pathname,
          // Bal küpü: ekranda görünmeyen alan. İnsanda boş kalır.
          website: form.website ? form.website.value : '',
          ...(turnstileField && turnstileField.value
            ? { turnstileToken: turnstileField.value }
            : {})
        })
      });
      if (!res.ok) throw new Error(res.status);
    } catch (err) {
      rest();
      // Jeton harcandı; bir sonraki deneme için yenisi gerekiyor.
      if (window.turnstile) window.turnstile.reset();
      status.setAttribute('data-error', '');
      status.textContent = msg('form.error', 'Gönderilemedi — lütfen tekrar deneyin.');
      return;
    }

    rest();
    if (window.turnstile) window.turnstile.reset();
    status.textContent = msg('form.success', 'Teşekkürler — özetiniz alındı. İki iş günü içinde dönüş yapacağız.');
    form.reset();
  });
})();
